import { useMemo } from 'react';
import { useQuery } from '@tanstack/react-query';
import { platformApi } from '../api/endpoints/platform';

/** Mapa cognitoSub → nombre de los administradores de plataforma (para columnas de auditoría). */
export function usePlatformAdminNames(enabled: boolean): ReadonlyMap<string, string> {
    const { data } = useQuery({
        queryKey: ['platform', 'admins'],
        queryFn: () => platformApi.listPlatformAdmins(),
        enabled,
    });
    return useMemo(
        () => new Map((data?.items ?? []).map((a) => [a.cognitoSub, a.displayName || a.email])),
        [data],
    );
}
